import React, {useState, useMemo, useEffect} from "react";
import { useParams } from "react-router-dom";
import { t } from '../../content';

import TeamReviewEdit from "./TeamReviewEdit";
import TeamList from "./TeamList";
import InviteTeamModal from "../teamReviewComponents/InviteTeamModal";

import filterAZ from '../../assets/images/icons/filterAZ.svg';
import Button from "../reusableElementsComponents/Button";
import WriteAccessGuard from "../reusableElementsComponents/WriteAccessGuard";
import B2BApiService from "../../B2bApiService";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import * as Constants from '../../constants'
import * as Utils from '../../Utilities'
import { ToastContainer } from 'react-toastify';

function TeamReviewLayoutDesktop() {

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    const { hash: requestedTeamHash } = useParams();

    let [teamsData, setTeamsData] = useState([]);
    let [selectedTeamHash, setSelectedTeamHash] = useState(requestedTeamHash || "");
    let [isLoadingSingleTeam, setIsLoadingSingleTeam] = useState(false);
    let [modalShow, setModalShow] = useState(false);

    useEffect(() => {
        if (teamsData && teamsData.length === 0) {
            b2bServiceObj.LoadTeamsWithAllData(data => {
                setTeamsData(data);
                if (data && data.length > 0 && !selectedTeamHash) {
                    setSelectedTeamHash(data[0].hash);
                }
            });
        }
    }, [b2bServiceObj, teamsData, selectedTeamHash]);

    const refreshAllTeamsData = () => {
        b2bServiceObj.LoadTeamsWithAllData(data => {
            setTeamsData(data);
            if (data && data.length > 0) {
                setSelectedTeamHash(data[0].hash);
            }
        })
    }

    const refreshSingleTeamData = (hash) => {
        setIsLoadingSingleTeam(true);
        b2bServiceObj.LoadTeamByHash(hash, (data) => {
            setIsLoadingSingleTeam(false);
            setSelectedTeamHash(data.hash);
            setTeamsData(prevTeams => {
                return prevTeams.map(team => {
                    if (team.hash === data.hash) {
                        return data;
                    }
                    return team;
                });
            });
        });
    }

    return (
        <div className="team-review-desktop">
            <ToastContainer autoClose={1000} containerId="teamManagementToast"/>
            {/* DONOT allow team lead or specialist to add new team */}
            {![Constants.USER_ROLE_TEAMLEAD, Constants.USER_ROLE_SPECIALIST].includes(Utils.currentUserRole()) &&
                <>
                <div className="add-team">
                    <WriteAccessGuard>
                        <Button btnstyle={'mazhrBtn default-green'} onClick={() => setModalShow(true)} id="add-new-team">
                            <AddCircleOutlineIcon/> &nbsp;{t('teams.addNewTeam')}
                        </Button>
                    </WriteAccessGuard>
                </div>
                <InviteTeamModal modalShow={modalShow} modalHide={setModalShow} refreshAllTeamsData={refreshAllTeamsData} />
                </> 
            }
            <div className="teams-wrapper m-0">
                <div className="teams-filters">
                    <div className="filter p-0 teams">
                        <p className="filter-title p-0 xs bold">{t('nav.items.teams')}</p>
                        <img src={filterAZ} alt="filter a-z"/>
                    </div>
                    <div className="filter p-0 team-members">
                        <p className="filter-title p-0 xs bold">{t('teams.teamMembers')}</p>
                        <img src={filterAZ} alt="filter a-z"/>
                    </div>
                    <div className="spacer"/>
                </div>

                <div className="teams p-0">
                    {
                        teamsData &&
                        <TeamList
                            teamsData={teamsData}
                            selectedTeamHash={selectedTeamHash}
                            onSelectedFunction={hash => setSelectedTeamHash(hash)}
                            isLoadingSingleTeam={isLoadingSingleTeam}
                        />
                    }
                    <div className="edit-field">
                        {selectedTeamHash && 
                            <TeamReviewEdit 
                                teamsData={teamsData}
                                selectedTeamHash={selectedTeamHash} 
                                setIsLoadingSingleTeam={setIsLoadingSingleTeam} 
                                refreshSingleTeamData={refreshSingleTeamData}
                            />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeamReviewLayoutDesktop;
